import { useMutation, UseMutationOptions } from 'react-query'

import { operations } from 'driverama-core/api/driverama/generated/orders'
import { HTTPMethod } from 'driverama-core/constants/rest'
import { apiAuthFetcher } from 'utils/authFetcher'

import { URLS } from 'constants/api'

export type NoteCreateBody = operations['createOrderNote_1']['requestBody']['content']['application/json']
export type NoteCreateResponse =
  | operations['createOrderNote_1']['responses']['200']['content']['application/com.driverama-v1+json']
  | undefined

type MutationOpts = UseMutationOptions<
  NoteCreateResponse,
  unknown,
  NoteCreateBody
>

export function useNoteCreateMutation(orderId: string, opts?: MutationOpts) {
  return useMutation<NoteCreateResponse, unknown, NoteCreateBody>(
    async body => {
      const res = await apiAuthFetcher<NoteCreateResponse>(
        URLS.orderNoteCreate(orderId),
        {
          method: HTTPMethod.POST,
          body
        }
      )
      return res.json
    },
    opts
  )
}
